import { ProductType, RegimeLogic } from '@/constant';
import {
  ProductVatConfigCreatePayload,
  ProductVatConfigQueryParams,
} from '@/types/product-vat-config.types';

export interface ProductVatConfigScreenConfig {
  basePath: string;
  managementDescription: string;
  createButtonLabel: string;
  listingTitle: string;
  formTitle: string;
  entityLabel: string;
  showIossEligibleColumn?: boolean;
  hideProductTypeField?: boolean;
  hideProductTypeColumn?: boolean;
  listQueryParams?: Partial<ProductVatConfigQueryParams>;
  restrictedOptions?: {
    productTypes?: ProductType[];
    regimeLogics?: RegimeLogic[];
    domesticCountryCode?: string;
  };
  forcePayload?: Partial<ProductVatConfigCreatePayload>;
}

export const defaultProductVatConfigScreen: ProductVatConfigScreenConfig = {
  basePath: '/product-vat-config',
  managementDescription: 'Manage default VAT configuration for products.',
  createButtonLabel: 'Add New VAT Config',
  listingTitle: 'Product VAT Configurations',
  formTitle: 'VAT Config',
  entityLabel: 'VAT config',
  showIossEligibleColumn: true,
};

export const domesticVatConfigScreen: ProductVatConfigScreenConfig = {
  basePath: '/domestic-vat-config',
  managementDescription:
    'Manage domestic VAT configuration for harbor addon products.',
  createButtonLabel: 'Add New Domestic VAT Config',
  listingTitle: 'Domestic VAT Configurations',
  formTitle: 'Domestic VAT Config',
  entityLabel: 'domestic VAT config',
  showIossEligibleColumn: false,
  listQueryParams: {
    config_type: 'HARBOR_ADDON',
  },
  restrictedOptions: {
    productTypes: [ProductType.HARBOUR_ADDON],
    regimeLogics: [RegimeLogic.DOMESTIC_ONLY],
    domesticCountryCode: 'FI',
  },
  forcePayload: {
    config_type: 'HARBOR_ADDON',
    product_type: ProductType.HARBOUR_ADDON,
    default_regime_logic: RegimeLogic.DOMESTIC_ONLY,
    eligible_for_ioss: false,
    domestic_country_code: 'FI',
  },
};

export const businessEntityVatConfigScreen: ProductVatConfigScreenConfig = {
  basePath: '/business-entity-vat-config',
  managementDescription:
    'Manage harbor business entity VAT configuration by domestic country.',
  createButtonLabel: 'Add New Business Entity VAT Config',
  listingTitle: 'Business Entity VAT Configurations',
  formTitle: 'Business Entity VAT Config',
  entityLabel: 'business entity VAT config',
  showIossEligibleColumn: false,
  hideProductTypeField: true,
  hideProductTypeColumn: true,
  listQueryParams: {
    config_type: 'HARBOR_BUSINESS_ENTITY',
  },
  restrictedOptions: {
    regimeLogics: [RegimeLogic.DOMESTIC_ONLY],
  },
  forcePayload: {
    config_type: 'HARBOR_BUSINESS_ENTITY',
    default_regime_logic: RegimeLogic.DOMESTIC_ONLY,
    eligible_for_ioss: false,
  },
};
